import React from 'react';
import { Box } from '@wix/design-system';
import TemplateCardImage from '../TemplateCardImage';
import s from '../TemplateCard.module.scss';
const TemplateLoadedCard = _ref => {
  let {
    template,
    index,
    hover,
    setHover,
    overlayContent,
    loadedCardClassName,
    mediaContainerClassName,
    CardInfo,
    showFeatures
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    verticalAlign: "middle",
    dataHook: "desktop-card",
    className: loadedCardClassName ? `${s.template} ${loadedCardClassName}` : s.template
  }, /*#__PURE__*/React.createElement(TemplateCardImage, {
    imageSource: template.media?.longThumbnail?.url,
    description: template.media?.longThumbnail?.description ?? '',
    index: index,
    animatedPreview: template.media?.animatedPreview,
    hovered: hover,
    overlayContent: overlayContent,
    mediaContainerClassName: mediaContainerClassName
  }), /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setHover(true)
  }, /*#__PURE__*/React.createElement(CardInfo, {
    template: template,
    hovered: hover,
    showFeatures: showFeatures
  })));
};
export default TemplateLoadedCard;
//# sourceMappingURL=TemplateLoadedCard.js.map